import * as React from "react";
import { SVGProps } from "react";
const IconQuote = (props: SVGProps<SVGSVGElement>) => (
  <svg
    className="icon-quote"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 40 35.64"
    xmlSpace="preserve"
    {...props}
  >
    <path
      fill="currentColor"
      d="M30,17.1H24V0H40V12.94q0,21.2-16,22.7V29.23q6-1.8,6-10.28Zm-24,0H0V0H16V12.94q0,21.2-16,22.7V29.23Q6,27.43,6,19Z"
    />
  </svg>
);
export default IconQuote;
